/**
 * Configuration for maximum number of selections allowed per filter category
 *
 * Set to null for no limit (unlimited selections)
 * Set to a number to limit the maximum selections
 */
export const FILTER_SELECTION_LIMITS = {
  activity: null, // No limit
  location: 2, // Maximum 2 selections
  day: 1 // Maximum 1 selection
} as const;

/**
 * Get the maximum number of selections allowed for a filter category
 * @param category - The filter category ('activities' | 'locations' | 'days')
 * @returns The maximum number of selections allowed, or null if unlimited
 */
export const getFilterLimit = (
  category: "activities" | "locations" | "days"
): number | null => {
  const categoryMap: Record<
    "activities" | "locations" | "days",
    "activity" | "location" | "day"
  > = {
    activities: "activity",
    locations: "location",
    days: "day"
  };

  const filterType = categoryMap[category];
  return FILTER_SELECTION_LIMITS[filterType] ?? null;
};

/**
 * Check if a selection can be added based on the current selections and limit
 * @param currentSelections - Array of currently selected items
 * @param limit - Maximum number of selections allowed (null for unlimited)
 * @returns true if a new selection can be added, false otherwise
 */
export const canAddSelection = (
  currentSelections: string[],
  limit: number | null
): boolean => {
  if (limit === null) return true;
  return currentSelections.length < limit;
};
